import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 cursor-pointer">
            <span className="text-2xl font-heading font-bold text-primary-500">
              91麻豆
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : scrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-300'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : scrolled
                    ? 'text-foreground-700 hover:text-primary-500'
                    : 'text-white hover:text-primary-300'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : scrolled
                  ? 'text-foreground-700 hover:text-primary-500'
                  : 'text-white hover:text-primary-300'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium rounded-md border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              立即加入
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="导航菜单"
          >
            <i
              className={`text-xl ${
                scrolled ? 'text-foreground-800' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-white border-t border-background-200/70">
            <div className="px-4 py-4 flex flex-col gap-3">
              <Link to="/" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer">
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="text-sm font-medium text-foreground-700 hover:text-primary-500 py-2 cursor-pointer">
                关于我们
              </Link>
              <div className="flex gap-3 pt-2">
                <Link
                  to="/about"
                  className="flex-1 text-center px-4 py-2 text-sm font-medium rounded-md border border-primary-500 text-primary-500 hover:bg-primary-500 hover:text-white transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  登录
                </Link>
                <Link
                  to="/about"
                  className="flex-1 text-center px-4 py-2 text-sm font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
                >
                  立即加入
                </Link>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}